import React from 'react'
import {translate} from 'react-i18next'
import Helmet from 'react-helmet'
import Header from '../components/Header.js'

const Contact = translate('contact')(
  ({t}) => (
    <div id="contact">
      <Header current="contact" />
      <div className="container">
        <div className="col1 col-pad1">
          <h1 className="page-title">Contact</h1>
        </div>
        <div className="col3">
          <form name="contact" action="/thanks/" method="POST" data-netlify="true">
            <input type="hidden" name="form-name" value="contact" />
            <label htmlFor="name">Name</label>
            <input type="text" id="name" name="name" />
            <label htmlFor="email">Mail</label>
            <input type="email" id="email" name="email" />
            <label htmlFor="category">Category</label>
            <select name="category" id="category">
              <option value="pr">{t('pr')}</option>
              <option value="hr">{t('hr')}</option>
              <option value="bz">{t('bz')}</option>
              <option value="ot">{t('ot')}</option>
            </select>
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" />
            <button type="submit" className="btn btn-primary col1">Send</button>
          </form>
        </div>
      </div>
    </div>
  )
)

export default () => (
  <div>
    <Helmet
      meta={[
        {name: 'description', content: 'Babels Contact'},
        {property: 'og:title', content: 'Babels Contact'},
        {property: 'og:url', content: 'https://babels.co/contact'},
        {property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff'},
        {property: 'og:image:width', content: '600'},
        {property: 'og:image:height', content: '400'},
        {property: 'og:description', content: 'Babels Contact'},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:site', content: '@null'},
        {name: 'twitter:creator', content: '@null'}
      ]}
    />
    <Contact />
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/contact.js